import { TEditConfigurationGeneralItem, TProjectConfigurationParameter } from 'pages/common/types';
import { TPatchProjectPayload } from '../types';

type TParams = {
  payload: TPatchProjectPayload;
  approximateTotalAmount: number;
  configurationParameters: TProjectConfigurationParameter[];
  generalItems: TEditConfigurationGeneralItem[];
  regionId?: string;
};

export const getPatchProjectConfigurationBody = ({
  payload,
  approximateTotalAmount,
  configurationParameters,
  generalItems,
  regionId,
}: TParams) => ({
  ...(regionId ? { regionId } : {}),
  approximateTotalAmount,
  configurationParameters,
  generalItems,
  relatedProjectId: payload.relatedProjectId,
  ...(payload.quotationId ? { quotationId: payload.quotationId } : {}),
  ...(payload.cartId ? { cartId: payload.cartId } : {}),
  author: payload.author,
});
